import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthTokenService } from "../services/auth-token.service";

@Injectable({ providedIn: 'root' })
export class UnrestrictedGuard implements CanActivate {
  private readonly authTokenService = inject(AuthTokenService);
  private readonly router = inject(Router);

  canActivate(): Promise<boolean | UrlTree> {
    return this.authTokenService.getIdToken().then(
      () => this.router.createUrlTree(['/template-list']),
      () => true
    );
  }
}
